export default __webpack_public_path__ + "static/media/SeaStars_04.b1cd4cfa.png";